__turbopack_context__.v({
  "input": "CheckButton-module-scss-module__KmPVgq__input",
  "label": "CheckButton-module-scss-module__KmPVgq__label",
});
